const sliders = document.querySelectorAll(".image-slider");

sliders.forEach((slider) => {
  const handle = slider.querySelector(".slider-handle");
  const afterImage = slider.querySelector(".image-container.after");
  const beforeLabel = slider.querySelector(".label.before");
  const afterLabel = slider.querySelector(".label.after");

  let isDragging = false;
  let sliderRect = null;

  function updateSlider(offsetX, rectWidth) {
    const percentage = (offsetX / rectWidth) * 100;

    // Update image clipping
    afterImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    handle.style.left = `${percentage}%`;

    // Labels fade near edges
    const fadeZone = 10;
    beforeLabel.style.opacity = percentage < fadeZone ? 0 : 1;
    afterLabel.style.opacity = percentage > 100 - fadeZone ? 0 : 1;

    // Image opacity
    // afterImage.style.opacity = percentage / 100;
  }

  function startDrag(e) {
    isDragging = true;
    sliderRect = slider.getBoundingClientRect();
    document.body.style.cursor = "ew-resize";
    handle.classList.add("active");
  }

  function stopDrag() {
    isDragging = false;
    document.body.style.cursor = "";
    handle.classList.remove("active");
  }

  function moveSlider(clientX) {
    if (!isDragging || !sliderRect) return;
    let offsetX = clientX - sliderRect.left;
    offsetX = Math.max(0, Math.min(offsetX, sliderRect.width));
    updateSlider(offsetX, sliderRect.width);
  }

  // Mouse events
  handle.addEventListener("mousedown", startDrag);
  window.addEventListener("mouseup", stopDrag);
  window.addEventListener("mousemove", (e) => moveSlider(e.clientX));

  // Touch events
  handle.addEventListener("touchstart", (e) => startDrag(e.touches[0]));
  window.addEventListener("touchend", stopDrag);
  window.addEventListener("touchmove", (e) => moveSlider(e.touches[0].clientX));

  // Initialize in middle
  const rect = slider.getBoundingClientRect();
  updateSlider(rect.width / 2, rect.width);
});
